<template>
    <div class="defent-register-con">
        <div class="defent-search-con">
            <el-form class="leader-style-form" :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="缺陷来源">
                    <el-select v-model="searchForm.defect_source">
                        <el-option
                            v-for="item in defectSource"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="缺陷单号">
                    <el-input maxlength="50" v-model="searchForm.defect_no"></el-input>
                </el-form-item>
                <el-form-item label="缺陷发现人">
                    <el-input maxlength="50" v-model="searchForm.founder"></el-input>
                </el-form-item>
                <el-form-item label="缺陷发现日期">
                    <el-date-picker
                        v-model="searchForm.found_time"
                        type="date"
                        placeholder="选择日期"
                        :default-value="timeNow"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        @click="getDefectList"
                        type="warning"
                        style="float: right; margin-left: 10px;"
                    >查询</el-button>
                    <el-button @click="addDefent" type="primary" style="float: right">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap">
            <el-table border :data="tableData" class="leader-style-table">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="缺陷单号" property="defect_no" align="center"></el-table-column>
                <el-table-column label="缺陷设备名称" property="tree_name" align="center"></el-table-column>
                <el-table-column label="缺陷性质" property="defect_level_name" align="center"></el-table-column>
                <el-table-column label="发现人" property="founder" align="center"></el-table-column>
                <el-table-column label="发现时间" property="found_time" align="center"></el-table-column>
                <el-table-column label="缺陷来源" property="defect_source_name" align="center"></el-table-column>
                <el-table-column label="缺陷状态" property="dual_method_name" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="changeItemShow(scope.row)"
                            type="text"
                            class="button-modify"
                            v-if="scope.row.dual_method == '10'"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="button-delete"
                            v-if="scope.row.dual_method == '10'"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                        <el-button
                            @click="detailsItemShow(scope.row)"
                            type="text"
                            class="button-custom"
                        >
                            <i class="iconfont iconsearch"></i>
                            <span class="inner-text">查看</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <AddDefentDialog
            :defentDialogVisible.sync="defentDialogVisible"
            :defect_id.sync="defect_id"
            :lookLook.sync="lookLook"
            @updateBeginData="updateBeginData"
            class="leader-dialog"
        ></AddDefentDialog>
    </div>
</template>
<script>
import AddDefentDialog from './components/add_defent_dialog';
import * as api from '../api/index';
export default {
    components: { AddDefentDialog },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            searchForm: {
                defect_source: '', //缺陷来源
                defect_no: '', //缺陷单号
                founder: '', //缺陷发现人
                found_time: '', //缺陷发现日期
            },
            defectSource: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            tableData: [],
            defentDialogVisible: false,
            defect_id: '', //需要传递的参数id
            lookLook: false,
        };
    },
    mounted() {
        this.getDefectSource();
        this.getDefectList();
    },
    methods: {
        //获取缺陷来源
        getDefectSource() {
            api.getCodelistByKind({
                code_kind: 'defect_source',
            }).then((res) => {
                if (res) {
                    this.defectSource = res.bus_json[0].codelists;
                }
            });
        },
        //获取缺陷列表
        getDefectList() {
            api.getDefectList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                defect_source: this.searchForm.defect_source,
                defect_no: this.searchForm.defect_no,
                founder: this.searchForm.founder,
                found_time: this.searchForm.found_time,
            }).then((res) => {
                if (res) {
                    this.tableData = res.bus_json.items;
                    this.pageNum = res.bus_json.pageNum;
                    this.pageSize = res.bus_json.pageSize;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        //新增缺陷
        addDefent() {
            this.defentDialogVisible = true;
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getDefectList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getDefectList();
        },
        //弹窗保存更新
        updateBeginData() {
            this.getDefectList();
        },
        //修改
        changeItemShow(row) {
            this.defentDialogVisible = true;
            this.defect_id = row.defect_id;
            this.lookLook = false;
        },
        //查看
        detailsItemShow(row) {
            this.defentDialogVisible = true;
            this.defect_id = row.defect_id;
            this.lookLook = true;
        },
        //删除
        deleteItemShow(row) {
            this.$confirm('您确定删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                api.deleteDefectById({
                    defect_id: row.defect_id,
                }).then((res) => {
                    if (res) {
                        this.$message({
                            type: 'success',
                            message: res.error_msg,
                        });
                        this.getDefectList();
                    }
                });
            });
        },
    },
};
</script>
<style lang="scss">
.defent-register-con {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .table-wrap {
        width: 100%;
        height: 700px;
    }
    .defent-table-con {
        padding: 0 30px;
    }
}
</style>
